/* LH | 2-pack set switch ("2er-Set Schalter", Leon 21.10.2026). Config and rules: snippets/lh-set-switch.liquid.
 *
 * Rules and reasons (plain English):
 * - The partner (e.g. Printlabs for the lantern) cannot process a separate upsell line. So this switch
 *   never adds a cart line. It changes the selected variant: ON = set variant, OFF = single variant.
 * - The change is made through TeeInBlue's own "Verfügbare Produkte" radio (one radio per TeeInBlue base
 *   product). We click the label of the matching radio, exactly like a customer would. TeeInBlue then
 *   loads the base product of the set (its print area and price), keeps the personalisation fields and
 *   adds the set variant with its print file properties to the cart itself. Clicking the input element
 *   directly does nothing in TeeInBlue (tested 22.10.2026), the label click does.
 * - Which radio is which: the radio label equals an option value of the variant (e.g. "Weinglas (einzel)"
 *   and "Weinglas (2er-Set)"). The switch only works when the radio group has exactly these two
 *   options. Otherwise the block stays hidden and the TeeInBlue radio is left alone.
 * - While the switch serves the product, the TeeInBlue radio group (with its title) is hidden, so there are not two
 *   controls for the same thing. The switch state is read from TeeInBlue's active radio, never stored
 *   separately, so both can never disagree (e.g. a link with ?variant=<set> shows the switch ON).
 * - This script never switches the set on by itself. Up to 25.10.2026 addon mode clicked the set once per page load,
 *   after TeeInBlue had started on the single; customers who turned it off got single lines with the set's two
 *   print files, which Printlabs rejects. Since 27.10.2026 addon mode preselects the set through the page start
 *   instead (snippets/lh-set-switch.liquid puts ?variant=<set> into the URL before TeeInBlue starts).
 * - Off for one product (config.off, from metafield custom.set_switch = false): switch and TeeInBlue radio both
 *   hidden, and if the set is active (e.g. a ?variant=<set> link) we click the single back.
 * - The block is moved into the TeeInBlue panel directly above the TeeInBlue buttons (#teeFormActions),
 *   as the LAST upsell block. Order of the blocks in the panel: gift bag, print file check, partner set, set switch, buttons (Leon, 23.10.2026).
 */
(function () {
  if (window.__lhSetLoaded) return;
  window.__lhSetLoaded = true;

  var busy = false;

  function root() { return document.querySelector('[data-lh-set]'); }

  var config = null;
  function cfg() {
    if (config) return config;
    var el = document.querySelector('[data-lh-set-config]');
    try { config = el ? JSON.parse(el.textContent) : null; } catch (e) { config = null; }
    return config;
  }

  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function field() { return document.querySelector('#tee-field--teeinblue-available-prod'); }

  // What we hide: the whole "Verfügbare Produkte" block (title + radios) when it holds nothing else,
  // otherwise only the radio field.
  function hideTarget() {
    var f = field();
    if (!f) return null;
    var block = f.closest('.tee-available-products');
    if (block && block.querySelectorAll('input').length === f.querySelectorAll('input').length) return block;
    return f;
  }

  // { main: radio wrapper, set: radio wrapper } or null when the radio group does not fit
  function radios() {
    var c = cfg();
    var f = field();
    if (!c || !f) return null;
    var wraps = Array.prototype.filter.call(f.querySelectorAll('.tee-radio'), function (w) {
      return w.querySelector('input[id^="teeinblue-available-prod-"]');
    });
    if (wraps.length !== 2) return null;
    // Only the options in which single and set differ tell them apart. FR tumbler (30.10.2026): the single is
    // "Verre / Verre / 430 ml", the set "Lot de 2 / Verre / 430 ml"; the colour "Verre" made the single's radio
    // "Verre" look like a value of both variants, so the switch stayed hidden.
    var mo = c.main.options || [], so = c.set.options || [];
    var mainOpts = mo.filter(function (o, i) { return norm(o) !== norm(so[i]); }).map(norm);
    var setOpts = so.filter(function (o, i) { return norm(o) !== norm(mo[i]); }).map(norm);
    var out = { main: null, set: null };
    wraps.forEach(function (w) {
      var label = w.querySelector('label');
      var text = norm(label && label.textContent);
      if (!text) return;
      // an option value both variants share (e.g. "Glas") cannot tell them apart
      var inMain = mainOpts.indexOf(text) !== -1;
      var inSet = setOpts.indexOf(text) !== -1;
      if (inMain && !inSet) out.main = w;
      if (inSet && !inMain) out.set = w;
    });
    return out.main && out.set ? out : null;
  }

  function isOn(r) { return !!(r && r.set.classList.contains('active')); }

  function setAttr(el, k, v) { if (el && el.getAttribute(k) !== v) el.setAttribute(k, v); }

  // ?lh_set_preview=1 shows the block although the product is switched off (QA of a new look before it goes on)
  function previewOn() { return /[?&]lh_set_preview=1(&|$)/.test(location.search); }

  // Live thumbnail, same as the keychain partner card (assets/lh-partner-upsell.js): clone TeeInBlue's live
  // preview (.tee-mockup) into the card so the customer sees their own design. Until then the product photo stays.
  var thumbTimer = null;
  var thumbSrc = null;
  function syncThumb() {
    var el = root();
    var box = el && el.querySelector('[data-lh-set-thumb]');
    var src = document.querySelector('#tee-gallery .tee-mockup-item--loaded .tee-mockup');
    // box.clientWidth is 0 while the block is still hidden: wait, a clone scaled to 0 stays invisible
    if (!box || !src || !src.offsetWidth || !src.offsetHeight || !box.clientWidth) return;
    var scale = Math.max(box.clientWidth / src.offsetWidth, box.clientHeight / src.offsetHeight);
    var key = scale + '|' + src.innerHTML;
    if (key === thumbSrc && box.querySelector('.lh-ss__live')) return;
    thumbSrc = key;
    var clone = src.cloneNode(true);
    clone.querySelectorAll('[id]').forEach(function (e) { e.removeAttribute('id'); });
    clone.style.position = 'absolute';
    clone.style.left = '0';
    clone.style.top = '0';
    clone.style.transformOrigin = '0 0';
    clone.style.transform = 'scale(' + scale + ')';
    clone.style.pointerEvents = 'none';
    var live = box.querySelector('.lh-ss__live');
    if (!live) {
      live = document.createElement('div');
      live.className = 'lh-ss__live';
      live.setAttribute('aria-hidden', 'true');
      box.appendChild(live);
    }
    live.replaceChildren(clone);
    box.classList.add('lh-ss__thumb--live');
  }
  function queueThumb() {
    clearTimeout(thumbTimer);
    thumbTimer = setTimeout(syncThumb, 250);
  }

  // Directly above the buttons: every other upsell block anchors to us or to a block above us,
  // so nothing ever wants the spot between us and the buttons.
  function anchor() {
    return document.querySelector('#teeFormActions');
  }

  function update() {
    var el = root();
    if (!el) return;
    var r = radios();
    var f = hideTarget();
    var c = cfg();
    if (r && c && c.off && !previewOn()) {
      // Off for this product (metafield custom.set_switch = false): no switch, no TeeInBlue radio, single only
      if (f && f.style.display !== 'none') { f.style.display = 'none'; f.dataset.lhSetHidden = '1'; }
      if (!el.classList.contains('lh-ss-hidden')) el.classList.add('lh-ss-hidden');
      if (isOn(r) && !busy) {
        var label = r.main.querySelector('label');
        if (label) { busy = true; label.click(); setTimeout(function () { busy = false; update(); }, 1500); }
      }
      return;
    }
    if (r) {
      var a = anchor();
      if (a && el.nextElementSibling !== a) a.insertAdjacentElement('beforebegin', el);
      if (f && f.style.display !== 'none') { f.style.display = 'none'; f.dataset.lhSetHidden = '1'; }
      if (el.classList.contains('lh-ss-hidden')) el.classList.remove('lh-ss-hidden');
      setAttr(el.querySelector('[data-lh-set-toggle]'), 'aria-checked', isOn(r) ? 'true' : 'false');
      var card = el.querySelector('[data-lh-set-card]');
      if (card && card.classList.contains('lh-ss-offcard') === isOn(r)) card.classList.toggle('lh-ss-offcard', !isOn(r));
      queueThumb();
    } else {
      if (!el.classList.contains('lh-ss-hidden')) el.classList.add('lh-ss-hidden');
      if (f && f.dataset.lhSetHidden) { f.style.display = ''; delete f.dataset.lhSetHidden; }
    }
  }

  function track(name) {
    try {
      var c = cfg();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, lh_upsell: 'set_switch', lh_set_sku: c ? c.set.sku : '' });
    } catch (e) {}
  }

  function toggle(auto) {
    var r = radios();
    if (!r || busy) return;
    var on = !isOn(r);
    var target = on ? r.set : r.main;
    var label = target.querySelector('label');
    if (!label) return;
    busy = true;
    var tog = root().querySelector('[data-lh-set-toggle]');
    setAttr(tog, 'aria-busy', 'true');
    setAttr(tog, 'aria-checked', on ? 'true' : 'false'); // instant feedback, confirmed by update()
    label.click();
    track(auto === true ? 'lh_set_preselect' : on ? 'lh_set_on' : 'lh_set_off');
    // TeeInBlue switches the base product asynchronously; check that it followed
    var tries = 0;
    (function check() {
      var now = radios();
      if ((now && isOn(now) === on) || tries++ > 40) {
        if (tries > 40) console.warn('[LH Set] TeeInBlue did not switch the product');
        busy = false;
        if (tog) tog.removeAttribute('aria-busy');
        update();
        return;
      }
      setTimeout(check, 100);
    })();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-lh-set-toggle],[data-lh-set-label]');
    var el = root();
    if (!t || !el || !el.contains(t)) return;
    e.preventDefault();
    toggle();
  });

  /* ---------- addon line (config.addon, Leon 23.10.2026, test in DE) ----------
   * Same pattern as the key chain partner set (assets/lh-partner-upsell.js): Teeinblue adds the set variant itself;
   * a click on its add to cart button arms a pending flag, after Teeinblue's add-to-cart event (backup: a successful
   * /cart/add response) we read /cart.js, take the newest set line whose _customization_id has no partner yet and add
   * ONE placeholder line with _partner_of = that _customization_id. window.__lhSetAddonPending tells the cart rules
   * (assets/lh-partner-upsell-cart.js) to wait, so they do not turn the set line back into the single meanwhile.
   *
   * Hardened 25.10.2026 after two orders reached the checkout with set lines and no placeholder (2 lanterns for the
   * price of 1: #HD-98377213, #HD-98377233):
   * - Teeinblue's event is "teeinblue-event-after-cart-added" (checked in its SDK); the old name never fired, so the
   *   addon only came through the /cart/add hook. Both names are listened to.
   * - A signal that finds no set line yet (the print file check is added first, on the same click) or arrives while a
   *   run is busy is not dropped any more: the run repeats until the set line is there, for as long as it is pending.
   * - When the pending state ends without an addon line (timeout or error), the cart rules run once, so a set line
   *   without its placeholder is turned back into the single right away and not only at the next cart change.
   * - window.lhSetAddonSettled() resolves once nothing is pending; the checkout gate in lh-partner-upsell-cart.js
   *   waits for it before it lets the customer into the checkout. */
  var addon = { pending: false, busy: false, again: false, added: false, timer: null, retry: null, tries: 0, waiters: [] };
  var RETRY_MS = 400;
  var MAX_TRIES = 25; // 10 s of retries, well inside the 15 s pending window
  function setPending(on) {
    var was = addon.pending;
    addon.pending = on;
    window.__lhSetAddonPending = on;
    // other tabs of the shop read this, their cart rules must not turn our fresh set line into the single (QA 26.10.2026)
    try {
      if (on) localStorage.setItem('lhSetAddonPendingUntil', String(Date.now() + 15000));
      else localStorage.removeItem('lhSetAddonPendingUntil');
    } catch (e) {}
    clearTimeout(addon.timer);
    clearTimeout(addon.retry);
    addon.tries = 0;
    if (on) {
      addon.timer = setTimeout(function () { setPending(false); }, 15000);
      return;
    }
    var w = addon.waiters.splice(0);
    w.forEach(function (fn) { try { fn(); } catch (e) {} });
    // ended without the addon (timeout, error): let the cart rules decide now
    if (was && !addon.added && typeof window.lhPartnerEnforce === 'function') window.lhPartnerEnforce();
    addon.added = false;
  }
  // The checkout gate gives up waiting: end the pending state the normal way (stops the retries, runs the cart rules).
  window.lhSetAddonCancel = function () { if (addon.pending) setPending(false); };
  window.lhSetAddonSettled = function () {
    if (!addon.pending) return Promise.resolve();
    return new Promise(function (resolve) { addon.waiters.push(resolve); });
  };
  function retryLater() {
    if (!addon.pending) return;
    if (++addon.tries > MAX_TRIES) { setPending(false); return; }
    clearTimeout(addon.retry);
    addon.retry = setTimeout(addAddon, RETRY_MS);
  }
  async function addAddon() {
    var c = cfg();
    if (!addon.pending || !c || !c.addon) return;
    if (addon.busy) { addon.again = true; return; }
    addon.busy = true;
    var done = false;
    try {
      var cart = await (await fetch('/cart.js', { headers: { 'X-LH-Partner': '1' } })).json();
      var partnered = {};
      cart.items.forEach(function (i) {
        if (i.properties && i.properties._partner_of) partnered[String(i.properties._partner_of)] = true;
      });
      var main = cart.items.find(function (i) {   // cart.items is newest first
        var cid = i.properties && i.properties._customization_id;
        return Number(i.variant_id) === Number(c.set.id) && cid && !partnered[String(cid)];
      });
      if (!main) return; // set line not in the cart yet: try again shortly (finally)
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-LH-Partner': '1' },
        body: JSON.stringify({ items: [{ id: c.addon.id, quantity: main.quantity || 1, properties: { _partner_of: String(main.properties._customization_id) } }] })
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      done = true;
      addon.added = true;
      setPending(false);
      track('lh_set_addon_added');
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        setTimeout(async function () {
          try {
            var r = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble');
            drawer.renderContents({ sections: await r.json() });
          } catch (e) {}
        }, 300);
      }
    } catch (e) {
      console.error('[LH Set] could not add the addon line', e);
    } finally {
      addon.busy = false;
      if (!done && addon.pending) {
        if (addon.again) { addon.again = false; setTimeout(addAddon, 50); }
        else retryLater();
      }
    }
  }
  document.addEventListener('click', function (e) {
    var atc = e.target.closest && e.target.closest('.tee-btn--atc');
    var c = cfg();
    if (!atc || !c) return;
    // The switch was just tapped and TeeInBlue is still loading the other base product: hold the click until it is
    // done, so the cart gets what the switch shows (QA 26.10.2026, IT: switch ON, single in the cart).
    if (busy && root() && !root().classList.contains('lh-ss-hidden')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (atc.dataset.lhSetHeld) return;
      atc.dataset.lhSetHeld = '1';
      var waited = 0;
      (function replay() {
        if (busy && waited < 5000) { waited += 100; setTimeout(replay, 100); return; }
        delete atc.dataset.lhSetHeld;
        if (atc.isConnected) atc.click();
      })();
      return;
    }
    if (!c.addon || !isOn(radios())) return;
    setPending(true);
  }, true);
  ['teeinblue-event-after-cart-added', 'teeinblue-event-after-add-to-cart'].forEach(function (name) {
    document.addEventListener(name, function () { setTimeout(addAddon, 100); });
  });
  // A /cart/add that carries the set variant arms the pending state as well, before the request goes out: the click
  // above can miss (switch still busy, keyboard, TeeInBlue re-rendering its button) and the cart rules would then turn
  // the set line into the single before the addon is in.
  function addsSet(body) {
    var c = cfg();
    if (!c || !c.addon || !body) return false;
    var text = typeof body === 'string' ? body : '';
    if (!text && typeof FormData !== 'undefined' && body instanceof FormData) text = String(body.get('id') || '') + ' ' + String(body.get('items[0][id]') || '');
    return new RegExp('(^|[^0-9])' + c.set.id + '([^0-9]|$)').test(text);
  }
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var h = (init && init.headers) || {};
    var own = (typeof h.get === 'function' ? h.get('X-LH-Partner') : h['X-LH-Partner']) === '1';
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    if (!own && isAdd && !addon.pending && addsSet(init && init.body)) setPending(true);
    var p = origFetch.apply(this, arguments);
    if (!own && addon.pending && isAdd) {
      p.then(function (res) { if (res && res.ok) setTimeout(addAddon, 250); }).catch(function () {});
    }
    return p;
  };

  var queued = false;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; if (!busy) update(); }, 30); // not rAF: it never fires in a tab opened in the background
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('teeinblue-event-component-injected', function () { setTimeout(update, 50); });
  window.addEventListener('load', function () { update(); setTimeout(update, 800); setTimeout(update, 2000); });
  if (document.readyState !== 'loading') update();
})();
